import gql from 'graphql-tag';

export const SETTINGS_QUERY = gql`
query getSettings
{
  terms: getSettingCategories{
    key
    label
    description
    settingDescriptions {
      key
      label
      description
      type
      defaultValue
      currentValue
      settings
      validators
    }
  },
}
`;

export interface SettingDescription {
  key: string;
  label: string;
  description: string;
  type: string;
  defaultValue: string;
  currentValue: string;
  settings: any;
  validators: any;
}

export interface SettingCategory {
  key: string;
  label: string;
  description: string;
  settingDescriptions: SettingDescription[];
}

export interface SettingsQueryResponse {
  terms: SettingCategory[];
}

